import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import Main from './modules/main/index.vue';
import ErrorPage from './modules/main/error-page/index.vue';
import homeRouter from './modules/home/router';
import studyRouter from './modules/study/router';
import centerRouter from './modules/center/router';
import centerVRouter from './modules/center-v/router';
import recommendRouter from './modules/recommend/router';
import shareContent from './modules/knowledge-operation/router';
import roomBookRouter from './modules/classroom-book/router';
import liveRouter from './modules/live/router';
import blackBoxRouter from './black-box/router';
import fullTextSearchRouter from './modules/full-text-search/router';
import loadJS from './util/load-js';
import configKnowledgeOperation from './config/config-knowledge-operation';

Vue.use(Router);

const routerConfig = {
    routes: [
        {
            path: '/',
            name: 'main',
            component: Main,
            children: [
                {
                    path: 'error-page-v/:code',
                    component: ErrorPage
                }
            ]
        },
    ],
    // 滚动条置顶
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    }
};
const routes = routerConfig.routes[0];
routes.children = routes.children.concat(
    blackBoxRouter(),
    homeRouter(),
    studyRouter(),
    centerRouter(),
    centerVRouter(),
    fullTextSearchRouter(),
    recommendRouter(),
    shareContent(),
    roomBookRouter(),
    liveRouter()
);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

const router = new Router(routerConfig);

// vue的路由占用了drizzlejs的路由 此时需要端开next, 重定向到drizzlejs路由去;
const minxinRouterLists = ['/home'];

router.beforeEach(async (to, from, next) => {
    await configKnowledgeOperation(store, to.path);
    let item;
    if (minxinRouterLists.includes(to.path)) {
        next(false);
    }
    if (to.path.startsWith('/center')) {
        item = loadJS.loadRules.center;
    } else {
        item = loadJS.loadRules[to.name];
    }
    if (item && !item.check()) {
        loadJS.load(item, next);
    } else {
        next();
    }
});

export default router;
